<template>
  <div>
    <d-input-group>
      <v-input
        v-model="form.insurance_company"
        name="insurance_company"
        class="column is-full"
      />
      <v-input
        v-model="form.insurance_number"
        name="insurance_number"
        class="column"
      />
      <v-input-date
        v-model="form.insurance_expiry_date"
        name="insurance_expiry_date"
        class="column"
      />
      <v-input-media
        v-model="form.insurance_picture_upload"
        name="insurance_picture_upload"
        :max="1"
        :mimes="['image/jpeg', 'image/png', 'image/svg+xml', 'image/webp', 'image/gif', 'application/pdf']"
        :existing-files="user ? user.insurance_picture : []"
        class="column is-full"
      />
    </d-input-group>
  </div>
</template>

<script>
import Fieldset from "@/plugins/form/Fieldset";

export default {
  extends: Fieldset,
  props: {
    user: {
      default: null,
      type: Object
    }
  }
};

</script>
